import React, { useCallback, useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import { apiV2 } from "../../api/axiosConfig";
import { PaginatedResponse } from "../../types/PaginatedResponse";
import { Client } from "../../types/userManagement";
import { useLoadClient } from "./useLoadClient";
import { reactSelectClassNames, reactSelectStyles } from "../react-select/styling";
import { MultiValue, MultiValueProps } from "react-select";
import { fetchSearchClient } from "./useClientSearch";
import { noop } from "../misc/noop";

type Option = {
  id: string;
  label: string;
  client: Client;
};

type ClientSelectV2Props = {
  rpp?: number;
  initialID?: string | null | undefined;
  onChange?: (selected: Client | undefined) => void;
  label ?: string;
  required?: boolean;
  isDisabled?: boolean;
  module?: string;
};

export const ClientSelectV2 = ({
  rpp = 20,
  initialID = null,
  onChange = noop,
    label,
    required = false,
    isDisabled = false,
    module,
}: ClientSelectV2Props) => {
  const { data: client, isLoading } = useLoadClient(initialID);
  const [selected, setSelected] = useState<Option | null>(null);

  useEffect(() => {
    if (isLoading || !initialID || !client) return;
    setSelected({
      id: client.id,
      label: client.name,
      client,
    });
  }, [client, isLoading, initialID]);

  const onSelect = useCallback(
    (option : any) => {
      if (option) {
        setSelected(option);
        onChange(option.client);
      } else {
        setSelected(null);
        onChange(undefined);
      }
    },
    [onChange]
  );

  const promiseOptions = useCallback(async (search: string) => {
    const results = await fetchSearchClient(search, rpp,null, module);
    if (!results) return [];
    return results.items.map((c) => ({
      label: c.name,
      value: c.id,
      client: c,
      id: c.id,
    }));
  }, [rpp, module]);

  if (isLoading) return null;

  return (
    <div className="flex flex-col relative">
        {label != undefined && (
            <label className="">
                {label}
                {required && <span className="text-dark-red"> *</span>}
            </label>
        )}
    <AsyncSelect
      classNames={reactSelectClassNames}
      styles={reactSelectStyles}
      placeholder="Select Client"
      value={selected}
      onChange={onSelect}
      cacheOptions
      defaultOptions
      loadOptions={promiseOptions}
      isClearable
      isDisabled={isDisabled}
    />
    </div>
  );
};
